<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    (blur)="onTouched()"
    [required]="required"
    [disabled]="disabled"
    [errorStateMatcher]="errorStateMatcher"
  >
    <mat-select-trigger>
      <div>
        <span>{{ value }} </span>
        <span class="full-name">{{ value | contractTypeFullName }}</span>
      </div>
    </mat-select-trigger>
    @for (contractType of ContractTypes; track $index) {
      <mat-option [value]="contractType">
        <div>
          <span>{{ contractType }} </span>
          <span class="full-name">{{ contractType | contractTypeFullName }}</span>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
